import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-300px",
  "data-kt-menu": "true"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "px-7 py-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "fs-5 text-dark fw-bolder" }, "Filter Options")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_4 = { class: "px-7 py-5" }
const _hoisted_5 = { class: "mb-10" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Status:", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Approved")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Pending")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("In Process")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Rejected")
const _hoisted_11 = { class: "mb-10" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Member Type:", -1)
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "\n              form-check form-check-sm form-check-custom form-check-solid\n              me-5\n            " }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "form-check-label" }, " Author ", -1)
const _hoisted_16 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "form-check-label" }, " Customer ", -1)
const _hoisted_18 = { class: "mb-10" }
const _hoisted_19 = /*#__PURE__*/_createVNode("label", { class: "form-label fw-bold" }, "Notifications:", -1)
const _hoisted_20 = { class: "\n            form-check\n            form-switch\n            form-switch-sm\n            form-check-custom\n            form-check-solid\n          " }
const _hoisted_21 = /*#__PURE__*/_createVNode("label", { class: "form-check-label" }, " Enabled ", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "reset",
    class: "btn btn-sm btn-white btn-active-light-primary me-2",
    "data-kt-menu-dismiss": "true"
  }, " Reset "),
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "btn btn-sm btn-primary",
    "data-kt-menu-dismiss": "true"
  }, " Apply ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", null, [
          _createVNode(_component_el_select, {
            class: "form-select-solid",
            placeholder: "Select option",
            modelValue: _ctx.data.status,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.data.status = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_option, {
                label: "Approved",
                value: "1"
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_option, {
                label: "Pending",
                value: "2"
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_el_option, {
                label: "In Process",
                value: "3"
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_el_option, {
                label: "Rejected",
                value: "4"
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode("div", _hoisted_13, [
          _createVNode("label", _hoisted_14, [
            _createVNode(_component_el_checkbox, {
              type: "checkbox",
              value: "1",
              modelValue: _ctx.data.author,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.data.author = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_15
          ]),
          _createVNode("label", _hoisted_16, [
            _createVNode(_component_el_checkbox, {
              type: "checkbox",
              value: "2",
              modelValue: _ctx.data.customer,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.data.customer = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_17
          ])
        ])
      ]),
      _createVNode("div", _hoisted_18, [
        _hoisted_19,
        _createVNode("div", _hoisted_20, [
          _withDirectives(_createVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            name: "notifications",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.data.notifications = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.data.notifications]
          ]),
          _hoisted_21
        ])
      ]),
      _hoisted_22
    ])
  ]))
}